/**
 * Null-Provider — der Default in Phase 2.1.
 *
 * Liefert konsequent status='no_data', sodass UI-Komponenten klar
 * kommunizieren: "Keine Marktdaten verbunden". Kein Crash, kein leeres "–".
 *
 * Wird ersetzt, sobald Phase 2.3 einen echten Provider liefert
 * (Finnhub / TwelveData / IBKR).
 */

import { DataStateHelpers } from '@/types';
import type { MarketDataProvider } from './types';

export const NULL_PROVIDER: MarketDataProvider = {
  name: 'Null-Provider (keine Marktdaten)',
  is_live: false,

  async lookupSymbol() {
    return DataStateHelpers.noData();
  },

  async getQuote() {
    return DataStateHelpers.noData();
  },

  async getOhlcv() {
    return DataStateHelpers.noData();
  },
};
